require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./apis-and-microservices-apis-and-microservices-projects-timestamp-microservice.json") })
        }
      }, "path---apis-and-microservices-apis-and-microservices-projects-timestamp-microservice");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---apis-and-microservices-apis-and-microservices-projects-timestamp-microservice!./.cache/json/apis-and-microservices-apis-and-microservices-projects-timestamp-microservice.json
// module id = 1250
// module chunks = 231608221292675